import { defineStore } from 'pinia';

export const traindata = defineStore('traindata', {
  state: () => ({
    token: null,
    isToaster: false,
    isSuccessToaster: false,
    isDangerToaster: false,
    toastrMsg: '',
    trainprocesdata: '',
    isHolidaySectionShow: true
  }),
  actions: {
    activateDangerToaster(val, type = 'd') {
      type == 'd' ? this.isDangerToaster = true : this.isSuccessToaster = true,
        this.toastrMsg = val;
      setTimeout(() => {
        this.isSuccessToaster = this.isDangerToaster = false;
        this.toastrMsg = '';
      }, 5000);
    },
    checkRouteAndSetState(route) {
      if (route.name === 'TrainSearchListView' || route.name === 'filghtDetails'  || route.name === 'filghtBookingDetails'|| route.name === 'refundTrainItem' || route.name === 'tourisBookingView'
        || route.name === 'tourismSearchList' || route.name === 'myLedgerView' || route.name === 'tourismBookView' || route.name === 'flightReport' || route.name === 'flightBookingreport'
       || route.name === 'trainTdrForm' || route.name === 'tdrRequestHistory' || route.name === 'TrainBookingFormView' || route.name === 'getTripCalendar') {
        this.isHolidaySectionShow = false
      }
      else
      {
        this.isHolidaySectionShow = true
      }
    }
  },

  persist: true,
});

